import { Pp } from "apparatus/library/common";
import { getDescendantIDs, getRootGroup } from "editing/grouping/operations";
import appStore from "store/store";
import { add } from "types";
/** Move an apparatus or an arrow. */
export class Move {
    /** IDs must be arrows or items. Groups are not supported. */
    constructor(ids, delta) {
        this.ids = ids;
        this.delta = Pp(delta);
    }
    execute() {
        appStore.dispatchFn("Move", Move.moveItem(this.ids, this.delta));
    }
    undo() {
        appStore.dispatchFn("Move", Move.moveItem(this.ids, this.delta.multiply(-1)));
    }
    static moveItem(ids, delta) {
        return state => (Object.assign(Object.assign({}, state), { items: state.items.map((item) => {
                if (ids.indexOf(item.id) === -1) {
                    return item;
                }
                return Object.assign(Object.assign({}, item), add(item, delta));
            }), arrows: state.arrows.map(arrow => {
                if (ids.indexOf(arrow.id) === -1) {
                    return arrow;
                }
                return Object.assign(Object.assign({}, arrow), { start: add(arrow.start, delta), end: add(arrow.end, delta) });
            }) }));
    }
    /** Moves a group. */
    static group(groupId, delta) {
        const group = appStore.groups().filter(g => g.id == groupId)[0];
        return new Move(getDescendantIDs(group), delta);
    }
    /** Moves one item. It can be an item, arrow or a group. */
    static one(id, delta) {
        if (id.type == "group") {
            return Move.group(id, delta);
        }
        return new Move([id], delta);
    }
}
/** Move individual items by different deltas. */
export class MoveIndividual {
    constructor(deltas) {
        this.itemDeltaMap = {};
        this.arrowDeltaMap = {};
        for (const { id, delta } of deltas) {
            switch (id.type) {
                case "apparatus":
                    this.itemDeltaMap[id.id] = delta;
                    break;
                case "arrow":
                    this.arrowDeltaMap[id.id] = delta;
                    break;
                case "group": {
                    for (const child of getDescendantIDs(getRootGroup(id))) {
                        if (child.type === "apparatus") {
                            this.itemDeltaMap[child.id] = delta;
                        }
                        else if (child.type === "arrow") {
                            this.arrowDeltaMap[child.id] = delta;
                        }
                    }
                }
            }
        }
    }
    execute() {
        appStore.dispatchFn("Move", state => this.moveItems(state, 1));
    }
    undo() {
        appStore.dispatchFn("Move", state => this.moveItems(state, -1));
    }
    moveItems(state, multiplier) {
        return Object.assign(Object.assign({}, state), { items: state.items.map((item) => {
                const delta = this.itemDeltaMap[item.id.id];
                if (delta === undefined)
                    return item;
                return Object.assign(Object.assign({}, item), add(item, delta.multiply(multiplier)));
            }), arrows: state.arrows.map(arrow => {
                const delta = this.arrowDeltaMap[arrow.id.id];
                if (delta === undefined)
                    return arrow;
                return Object.assign(Object.assign({}, arrow), { start: add(arrow.start, delta.multiply(multiplier)), end: add(arrow.end, delta.multiply(multiplier)) });
            }) });
    }
}
